
import api from '../../api/index.js'

const state = {

}

const getters = {
    
}

const actions = {
    // 获取墓园列表
    ActivityZyj({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/Activity/Zyj',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
